export default __webpack_public_path__ + "static/media/google_play_image.60646b0e.png";